import React from "react";

import WhatsAppButton from "../../AppViews/Footer/WhatsAppButton";
import LogoImage from "../components/LogoImage";
import BackgroundImage from "../components/BackgroundImage";
import Glassmorphism from "../components/Glassmorphism";
import Text from "../../../_components/Text";

// HOOKS
import { useAppendUtmParams } from "./hooks/useAppendUtmParams";

import LoginForm from "./components/form";
import SSOLogin from "./components/sso";

import { getConfig } from "../../../utils/config";

const config = getConfig();

const loginMethod = config.login.method;

export default () => {
  useAppendUtmParams();

  if (loginMethod === "sso") {
    return <SSOLogin />;
  } else {
    return (
      <BackgroundImage>
        <div className="container">
          <Glassmorphism>
            <div className="row">
              <div className="col-md-5 col-xs-12 mx-auto">
                <div>
                  <div className="d-flex justify-content-center">
                    <LogoImage
                      className="py-3"
                      src="https://content.easygestor.com/easygestor/logo_easygestor.png"
                      alt="Easygestor web logo image"
                    />
                  </div>
                  <Text align="center" as="h2" className="pb-4">
                    Bem-vindo(a) ao Easygestor Web!
                  </Text>
                  <Text align="justify">
                    O EasyGestor online é um Sistema de Gestão, voltado para
                    micro e pequenas empresas, 100% ausente de instalação, e com
                    um armazenamento gerenciado com tecnologia em nuvem. Para
                    mantermos o EasyGestor, algumas soluções específicas como,
                    emissão de NFe e NFCe, Controle de Estoque, Relatório de
                    Vendas, etc, serão cobradas, através de uma assinatura
                    mensal de acordo com a sua necessidade. Mas não se preocupe,
                    nenhum pagamento será feito sem a sua autorização prévia.
                  </Text>
                </div>
              </div>
              <LoginForm />
            </div>
          </Glassmorphism>
        </div>
        <WhatsAppButton />
      </BackgroundImage>
    );
  }
};



// WEBPACK FOOTER //
// ./src/views/Auth/Login/index.jsx